<!-- Estilos: src/assets/styles/components/_liga-ui.scss (.lx-*) y _liga-c.scss (.lxc-*). -->
<section class="lx-pagina" lang="es" [class.lx-pagina--con-cta]="conCtaFijo" [attr.aria-busy]="cargandoInicial ? 'true' : null">

  <!-- ===== Cargando: esqueleto dentro de la pantalla ===== -->
  <ng-container *ngIf="cargandoInicial; else contenido">
    <header class="lx-hero" aria-hidden="true">
      <div class="lx-hero__cabeza">
        <span class="lx-esqueleto lx-esqueleto--icono"></span>
        <div class="lx-hero__textos lx-pila lx-pila--chica">
          <span class="lx-esqueleto lx-esqueleto--corto"></span>
          <span class="lx-esqueleto lx-esqueleto--titulo"></span>
          <span class="lx-esqueleto"></span>
        </div>
      </div>
    </header>
    <div class="lx-tarjeta lx-pila" aria-hidden="true">
      <span class="lx-esqueleto lx-esqueleto--corto"></span>
      <span class="lx-esqueleto lx-esqueleto--campo"></span>
      <span class="lx-esqueleto lx-esqueleto--corto"></span>
      <span class="lx-esqueleto lx-esqueleto--campo"></span>
    </div>
    <p class="lx-seguro lxc-cargando" role="status">
      <span class="lx-seguro__icono" aria-hidden="true"><span class="lx-spinner"></span></span>
      <span>Revisando si ya tienes una cuenta validada…</span>
    </p>
  </ng-container>

  <ng-template #contenido>

    <!-- ===== No pudimos arrancar (sin ID del trabajador) ===== -->
    <ng-container *ngIf="errorInicial; else pasos">
      <div class="lx-vacio lxc-vacio-error" role="alert">
        <span class="lx-vacio__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
        <h2 class="lx-vacio__titulo">No pudimos cargar tus datos</h2>
        <p class="lx-vacio__texto" *ngIf="responseMessage[0]?.summary as detalle">{{detalle}}</p>
        <p class="lx-vacio__texto">Regresa a tus pasos y vuelve a entrar en unos minutos.</p>
        <!-- Igual que la flecha de la banda: regresa a la lista sin recargar el flujo. -->
        <button type="button" class="lx-btn lx-btn--primario" (click)="onEndProcess.emit(false)"><span>Volver a mis pasos</span></button>
      </div>
    </ng-container>

    <ng-template #pasos>
      <ng-container [ngSwitch]="step">

        <!-- ===== Ya tiene cuentas validadas ===== -->
        <ng-container *ngSwitchCase="'EXISTING'">
          <header class="lx-hero">
            <div class="lx-hero__cabeza">
              <span class="lx-hero__icono lx-hero__icono--verde" aria-hidden="true"><fa-icon [icon]="iconos.cartera"></fa-icon></span>
              <div class="lx-hero__textos">
                <span class="lx-hero__eyebrow">Cuenta para tus pagos</span>
                <h2 class="lx-hero__titulo">Ya tienes una cuenta validada</h2>
                <p class="lx-hero__subtitulo">Úsala para domiciliar tus pagos y avanzar más rápido, o registra otra.</p>
              </div>
            </div>
          </header>

          <ng-container *ngTemplateOutlet="rechazo"></ng-container>

          <div class="lx-tarjeta">
            <div class="lx-tarjeta__cabeza">
              <div>
                <h3 class="lx-tarjeta__titulo" id="druo-cuentas-titulo">Elige la cuenta</h3>
                <p class="lx-tarjeta__subtitulo">Ahí se harán los cargos automáticos de tus pagos.</p>
              </div>
              <span class="lx-chip lx-chip--suave" *ngIf="existingAccounts.length > 1">{{existingAccounts.length}} cuentas</span>
            </div>
            <div class="lx-opciones" role="radiogroup" aria-labelledby="druo-cuentas-titulo">
              <label class="lx-opcion" *ngFor="let account of existingAccounts; let i = index" [class.is-elegida]="i === cuentaElegida">
                <input class="lx-opcion__input" type="radio" name="druo-cuenta" [value]="i" [checked]="i === cuentaElegida"
                       [disabled]="enCurso !== '' || terminado" (change)="cuentaElegida = i">
                <span class="lx-opcion__marca" aria-hidden="true"></span>
                <span class="lxc-opcion-banco" aria-hidden="true"><fa-icon [icon]="iconos.banco"></fa-icon></span>
                <span class="lx-opcion__textos">
                  <span class="lx-opcion__titulo">{{nombreBanco(account.bankName) || 'Cuenta bancaria'}}</span>
                  <span class="lx-opcion__texto">CLABE con terminación {{terminacion(account.accountNumber)}}</span>
                  <span class="lx-chip lx-opcion__chip" [ngClass]="estadoCuenta(account).chip">
                    <fa-icon [icon]="estadoCuenta(account).icono" aria-hidden="true"></fa-icon>{{estadoCuenta(account).texto}}
                  </span>
                </span>
              </label>
            </div>

            <div class="lx-tarjeta__pie">
              <ng-container *ngTemplateOutlet="avisos"></ng-container>
              <ng-container *ngIf="terminado">
                <button type="button" class="lx-btn lx-btn--primario" (click)="terminar()"><span>Continuar</span></button>
                <p class="lx-celebracion__nota" role="status">Te regresamos a tus pasos en unos segundos.</p>
              </ng-container>
              <div class="lx-cta" *ngIf="!terminado">
                <button type="button" class="lx-btn lx-btn--primario" (click)="enCurso === '' && usarCuentaElegida()"
                        [disabled]="enCurso !== '' && enCurso !== 'usar'" [class.is-cargando]="enCurso === 'usar'" [attr.aria-busy]="enCurso === 'usar' ? 'true' : null">
                  <span class="lx-spinner" *ngIf="enCurso === 'usar'" aria-hidden="true"></span>
                  <span>{{enCurso === 'usar' ? 'Guardando tu cuenta…' : 'Usar esta cuenta'}}</span>
                </button>
                <button type="button" class="lx-btn lx-btn--secundario" (click)="registerNewAccount()" [disabled]="enCurso !== ''">
                  <fa-icon [icon]="iconos.agregar" aria-hidden="true"></fa-icon><span>Registrar otra cuenta</span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ===== Paso 1 de 3: CLABE + RFC ===== -->
        <ng-container *ngSwitchCase="'CLABE'">
          <ng-container *ngTemplateOutlet="hero; context: {
            icono: iconos.banco,
            titulo: 'Valida tu cuenta de nómina',
            subtitulo: 'La confirmamos con DRUO, un servicio seguro, y ahí autorizas el cobro automático de tus pagos.'
          }"></ng-container>

          <ng-container *ngTemplateOutlet="rechazo"></ng-container>

          <div class="lx-tarjeta">
            <h3 class="lx-tarjeta__titulo">Así validamos tu cuenta</h3>
            <ol class="lx-lista lx-lista--numerada" style="margin-top: 12px">
              <li>Escribe tu CLABE y confirma tu RFC.</li>
              <li>Te enviamos un microdepósito de unos centavos.</li>
              <li>Escribe cuántos centavos te llegaron y listo.</li>
            </ol>
          </div>

          <form class="lx-tarjeta" novalidate (ngSubmit)="alValidarCuenta()">
            <div class="lx-form">
              <fieldset class="lx-grupo">
                <legend class="lx-grupo__titulo"><fa-icon [icon]="iconos.banco" aria-hidden="true"></fa-icon>Tu cuenta de nómina</legend>

                <div class="lx-campo" [class.is-invalido]="!!errorClabe" [class.is-valido]="clabeCompleta">
                  <label class="lx-campo__etiqueta" for="druo-clabe">CLABE interbancaria</label>
                  <input class="lx-control lxc-clabe" id="druo-clabe" name="clabe" type="text" inputmode="numeric" pattern="[0-9]*"
                         autocomplete="off" autocorrect="off" spellcheck="false" placeholder="18 dígitos"
                         [value]="clabeVisible" (input)="alEscribirClabe($event)" (blur)="alSalirClabe()"
                         (paste)="onClabePaste($event); alSalirClabe()" [disabled]="enCurso !== ''"
                         [attr.aria-invalid]="errorClabe ? 'true' : null" aria-describedby="druo-clabe-pie">
                  <div class="lx-campo__pie" id="druo-clabe-pie">
                    <p class="lx-campo__error" *ngIf="errorClabe; else ayudaClabe">
                      <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon><span>{{errorClabe}}</span>
                    </p>
                    <ng-template #ayudaClabe>
                      <p class="lx-campo__ayuda">La encuentras en la app de tu banco o en tu estado de cuenta.</p>
                    </ng-template>
                    <span class="lx-campo__contador" aria-hidden="true">{{digitosClabe}}/{{longitudClabe}}</span>
                  </div>
                  <p class="lxc-banco" *ngIf="detectedBank && !errorClabe" role="status">
                    <span class="lxc-banco__icono" aria-hidden="true"><fa-icon [icon]="iconos.banco"></fa-icon></span>
                    <span class="lxc-banco__textos">
                      <strong>{{bancoDetectado}}</strong>
                      <span class="lxc-banco__ok"><fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon>Banco detectado y compatible</span>
                    </span>
                  </p>
                </div>

                <button type="button" class="lx-enlace lxc-alternar" (click)="alternarBancos()"
                        [attr.aria-expanded]="mostrarBancos" aria-controls="druo-bancos">
                  <span>Ver bancos compatibles ({{allBanks.length}})</span>
                  <fa-icon class="lxc-alternar__chevron" [icon]="iconos.chevron" aria-hidden="true"></fa-icon>
                </button>
                <div class="lxc-bancos" id="druo-bancos" [hidden]="!mostrarBancos">
                  <div class="lx-campo">
                    <label class="lx-campo__etiqueta lx-sr" for="druo-buscar-banco">Busca tu banco</label>
                    <input class="lx-control" id="druo-buscar-banco" type="search" placeholder="Busca tu banco" autocomplete="off"
                           enterkeyhint="search" [value]="busquedaBanco" (input)="alBuscarBanco($event)" (keydown.enter)="$event.preventDefault()">
                  </div>
                  <ul class="lxc-bancos__lista" aria-label="Bancos compatibles con DRUO">
                    <li class="lxc-bancos__banco" *ngFor="let banco of bancosVisibles">{{banco}}</li>
                  </ul>
                  <p class="lxc-bancos__vacio" *ngIf="!bancosVisibles.length" role="status">No encontramos ese banco. Por ahora DRUO solo trabaja con los de la lista.</p>
                </div>
              </fieldset>

              <fieldset class="lx-grupo" id="druo-rfc" tabindex="-1">
                <legend class="lx-grupo__titulo"><fa-icon [icon]="iconos.rfc" aria-hidden="true"></fa-icon>Tu RFC</legend>

                <ng-container [ngSwitch]="modoRfc">
                  <div class="lxc-rfc lxc-rfc--cargando" *ngSwitchCase="'cargando'" role="status">
                    <span class="lx-spinner" aria-hidden="true"></span>
                    <span>Buscando tu RFC en tu estado de cuenta…</span>
                  </div>

                  <div class="lxc-rfc" *ngSwitchCase="'detectado'" [class.is-pendiente]="pendienteRfc">
                    <div>
                      <p class="lxc-rfc__etiqueta">Lo tomamos de tu estado de cuenta</p>
                      <p class="lxc-rfc__valor">{{rfcVisible}}</p>
                    </div>
                    <p class="lx-campo__ayuda">¿Es igual al de tu estado de cuenta? Debe coincidir para validar tu cuenta.</p>
                    <div class="lx-acciones lx-acciones--fila lxc-rfc__acciones">
                      <button type="button" class="lx-btn lx-btn--secundario lx-btn--chico" (click)="enableRfcEdit()" [disabled]="enCurso !== ''">
                        <fa-icon [icon]="iconos.editar" aria-hidden="true"></fa-icon><span>Corregir</span>
                      </button>
                      <button type="button" class="lx-btn lx-btn--suave lx-btn--chico" (click)="confirmRfcAndContinue()" [disabled]="enCurso !== ''">
                        <fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon><span>Es correcto</span>
                      </button>
                    </div>
                    <p class="lx-campo__error" *ngIf="pendienteRfc">
                      <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon><span>Confirma tu RFC para continuar.</span>
                    </p>
                  </div>

                  <div class="lxc-rfc lxc-rfc--listo" *ngSwitchCase="'confirmado'">
                    <span class="lxc-rfc__check" aria-hidden="true"><fa-icon [icon]="iconos.listo"></fa-icon></span>
                    <div class="lxc-rfc__cuerpo">
                      <p class="lxc-rfc__etiqueta">RFC confirmado</p>
                      <p class="lxc-rfc__valor">{{rfcVisible}}</p>
                      <button type="button" class="lx-enlace lxc-rfc__cambiar" (click)="enableRfcEdit()" [disabled]="enCurso !== ''" aria-label="Cambiar RFC">
                        <fa-icon [icon]="iconos.editar" aria-hidden="true"></fa-icon><span>Cambiar</span>
                      </button>
                    </div>
                  </div>

                  <ng-container *ngSwitchCase="'editando'">
                    <div class="lx-campo" [class.is-invalido]="!!errorRfc">
                      <label class="lx-campo__etiqueta" for="druo-rfc-campo">RFC</label>
                      <input class="lx-control lxc-rfc__campo" id="druo-rfc-campo" type="text" [formControl]="rfcControl"
                             autocapitalize="characters" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="XXXX000000XXX"
                             (blur)="alSalirRfc()" (keydown.enter)="alEnterRfc($event)"
                             [attr.aria-invalid]="errorRfc ? 'true' : null" aria-describedby="druo-rfc-pie">
                      <div id="druo-rfc-pie">
                        <p class="lx-campo__error" *ngIf="errorRfc; else ayudaRfc">
                          <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon><span>{{errorRfc}}</span>
                        </p>
                        <ng-template #ayudaRfc>
                          <p class="lx-campo__ayuda">Escríbelo igual que en tu estado de cuenta: con homoclave o genérico, según tu banco.</p>
                        </ng-template>
                      </div>
                    </div>
                    <button type="button" class="lx-btn lx-btn--suave" (click)="alSalirRfc(); confirmRfcAndContinue()" [disabled]="enCurso !== ''">
                      <fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon><span>Guardar RFC</span>
                    </button>
                    <p class="lx-campo__error" *ngIf="pendienteRfc && !errorRfc">
                      <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon><span>Guarda tu RFC para continuar.</span>
                    </p>
                  </ng-container>
                </ng-container>
              </fieldset>
            </div>
          </form>

          <ng-container *ngTemplateOutlet="avisos"></ng-container>
          <ng-container *ngTemplateOutlet="seguro"></ng-container>
        </ng-container>

        <!-- ===== Paso 2 de 3: microdepósito ===== -->
        <ng-container *ngSwitchCase="'OTP'">
          <ng-container *ngTemplateOutlet="hero; context: {
            icono: iconos.banco,
            titulo: 'Escribe el microdepósito',
            subtitulo: 'Te depositamos unos centavos en tu cuenta con terminación ' + terminacion(clabe) + '. Escribe cuántos te llegaron.'
          }"></ng-container>

          <div class="lx-tarjeta">
            <h3 class="lx-tarjeta__titulo">¿Dónde lo veo?</h3>
            <ul class="lx-lista" style="margin-top: 12px">
              <li>Abre la app o la banca en línea de tu banco.</li>
              <li>Busca un depósito de menos de $1.00.</li>
              <li>Escribe solo los centavos: si te llegaron $0.37, escribe 37.</li>
            </ul>
          </div>

          <form class="lx-tarjeta" novalidate (ngSubmit)="enCurso === '' && validateOtp()">
            <div class="lx-form">
              <div class="lx-campo" [class.is-invalido]="!!errorOtp">
                <label class="lx-campo__etiqueta" for="druo-otp">Centavos que recibiste</label>
                <span class="lxc-centavos">
                  <span class="lxc-centavos__prefijo" aria-hidden="true">$0.</span>
                  <input class="lx-control lxc-centavos__campo" id="druo-otp" name="otp" type="text" inputmode="numeric" pattern="[0-9]*"
                         maxlength="2" autocomplete="off" placeholder="00" [formControl]="otpControl"
                         [readonly]="otpBlocked || enCurso !== ''" [attr.aria-disabled]="otpBlocked ? 'true' : null"
                         [attr.aria-invalid]="errorOtp ? 'true' : null" aria-describedby="druo-otp-pie">
                </span>
                <div id="druo-otp-pie">
                  <p class="lx-campo__error" *ngIf="errorOtp; else ayudaOtp">
                    <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon><span>{{errorOtp}}</span>
                  </p>
                  <ng-template #ayudaOtp>
                    <p class="lx-campo__ayuda">
                      <span class="lxc-intentos" aria-hidden="true">
                        <span *ngFor="let n of intentos" [class.is-usado]="n > remainingOtpAttempts"></span>
                      </span>
                      Te queda{{remainingOtpAttempts === 1 ? '' : 'n'}} {{remainingOtpAttempts}} intento{{remainingOtpAttempts === 1 ? '' : 's'}}. Si se acaban, tendrás que validar tu cuenta otra vez.
                    </p>
                  </ng-template>
                </div>
              </div>

              <ng-container *ngTemplateOutlet="avisos"></ng-container>

              <div class="lx-cta">
                <button type="submit" class="lx-btn lx-btn--primario"
                        [disabled]="otpBlocked || (enCurso !== '' && enCurso !== 'otp') || otpAttempts >= maxOtpAttempts"
                        [class.is-cargando]="enCurso === 'otp'" [attr.aria-busy]="enCurso === 'otp' ? 'true' : null">
                  <ng-container *ngIf="enCurso === 'otp'; else textoOtp">
                    <span class="lx-spinner" aria-hidden="true"></span><span>Confirmando…</span>
                  </ng-container>
                  <ng-template #textoOtp>
                    <ng-container *ngIf="otpBlocked; else textoOtpNormal">
                      <fa-icon [icon]="iconos.reloj" aria-hidden="true"></fa-icon><span>Vuelve a intentar en {{otpBlockTimer}} s</span>
                    </ng-container>
                    <ng-template #textoOtpNormal><span>Confirmar microdepósito</span></ng-template>
                  </ng-template>
                </button>
              </div>
            </div>
          </form>

          <ng-container *ngTemplateOutlet="seguro"></ng-container>
        </ng-container>

        <!-- ===== Paso 3 de 3: confirmar ===== -->
        <ng-container *ngSwitchCase="'CONFIRM'">
          <ng-container *ngTemplateOutlet="hero; context: {
            icono: iconos.listo,
            verde: true,
            titulo: terminado ? 'Tu cuenta quedó registrada' : 'Confirmamos tu cuenta',
            subtitulo: terminado ? 'Ya puedes seguir con tu solicitud.' : 'Solo falta guardarla en tu solicitud.'
          }"></ng-container>

          <div class="lx-celebracion">
            <div class="lx-celebracion__check">
              <svg class="lx-check" viewBox="0 0 52 52" aria-hidden="true">
                <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
                <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
              </svg>
            </div>
            <h3 class="lx-celebracion__titulo">{{terminado ? '¡Listo! Guardamos tu cuenta' : '¡Microdepósito correcto!'}}</h3>
            <ng-container *ngFor="let m of responseMessage; trackBy: porMensaje">
              <p class="lx-celebracion__msg" *ngIf="m.severity === 'success'" role="status">{{m.summary}}</p>
            </ng-container>
            <dl class="lx-datos" style="width: 100%; margin-top: 4px">
              <div class="lx-dato" *ngIf="bancoDetectado">
                <dt class="lx-dato__etiqueta">Banco</dt>
                <dd class="lx-dato__valor">{{bancoDetectado}}</dd>
              </div>
              <div class="lx-dato">
                <dt class="lx-dato__etiqueta">CLABE</dt>
                <dd class="lx-dato__valor">Terminación {{terminacion(clabe)}}</dd>
              </div>
            </dl>
            <ng-container *ngIf="terminado">
              <button type="button" class="lx-btn lx-btn--primario" (click)="terminar()"><span>Continuar</span></button>
              <p class="lx-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
            </ng-container>
          </div>

          <div class="lxc-avisos" aria-live="polite">
            <ng-container *ngFor="let m of responseMessage; trackBy: porMensaje">
              <ng-container *ngIf="m.severity !== 'success'">
                <ng-container *ngTemplateOutlet="alerta; context: {$implicit: m}"></ng-container>
              </ng-container>
            </ng-container>
          </div>

          <div class="lx-cta" *ngIf="!terminado">
            <button type="button" class="lx-btn lx-btn--primario" (click)="enCurso === '' && confirmCompletedProcess()"
                    [disabled]="enCurso !== '' && enCurso !== 'confirmar'" [class.is-cargando]="enCurso === 'confirmar'" [attr.aria-busy]="enCurso === 'confirmar' ? 'true' : null">
              <span class="lx-spinner" *ngIf="enCurso === 'confirmar'" aria-hidden="true"></span>
              <span>{{enCurso === 'confirmar' ? 'Guardando tu cuenta…' : 'Terminar y continuar'}}</span>
            </button>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>
  </ng-template>
</section>

<!-- CTA fijo (hermano de la página: ningún ancestro con animación ni transform) -->
<div class="lx-cta-fijo" *ngIf="conCtaFijo">
  <button type="button" class="lx-btn lx-btn--primario" (click)="enCurso === '' && alValidarCuenta()"
          [disabled]="!startButtonIsAvailable || (enCurso !== '' && enCurso !== 'conectar')" [class.is-cargando]="enCurso === 'conectar'"
          [attr.aria-busy]="enCurso === 'conectar' ? 'true' : null">
    <span class="lx-spinner" *ngIf="enCurso === 'conectar'" aria-hidden="true"></span>
    <span>{{enCurso === 'conectar' ? 'Validando tu cuenta…' : 'Validar mi cuenta'}}</span>
  </button>
  <p class="lx-cta-fijo__nota"><fa-icon [icon]="iconos.seguro" aria-hidden="true"></fa-icon>Luego te enviamos un microdepósito.</p>
</div>

<!-- ===== Piezas compartidas ===== -->
<ng-template #hero let-icono="icono" let-titulo="titulo" let-subtitulo="subtitulo" let-verde="verde">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono" [class.lx-hero__icono--verde]="verde" aria-hidden="true"><fa-icon [icon]="icono"></fa-icon></span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Cuenta para tus pagos</span>
        <h2 class="lx-hero__titulo">{{titulo}}</h2>
        <p class="lx-hero__subtitulo">{{subtitulo}}</p>
        <span class="lx-chip" *ngIf="data.comment && step === 'CLABE'" [ngClass]="estados.corrige.chip">
          <fa-icon [icon]="estados.corrige.icono!" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
        </span>
      </div>
    </div>
    <div class="lx-hero__pie">
      <ol class="lx-etapas" [attr.aria-label]="'Parte ' + pasoActual + ' de 3'">
        <li *ngFor="let n of segmentos" [class.is-listo]="n < pasoActual || terminado" [class.is-actual]="n === pasoActual && !terminado"
            [attr.aria-current]="n === pasoActual && !terminado ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="n < pasoActual || terminado; else numeroParte" [icon]="iconos.listo"></fa-icon><ng-template #numeroParte>{{n}}</ng-template></span>{{nombresPaso[n - 1]}}</span>
        </li>
      </ol>
    </div>
  </header>
</ng-template>

<ng-template #rechazo>
  <div class="lx-alerta lx-alerta--error" *ngIf="data.comment">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
    <div class="lx-alerta__cuerpo">
      <p class="lx-alerta__titulo">Necesitamos que lo corrijas</p>
      <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
    </div>
  </div>
</ng-template>

<ng-template #avisos>
  <div class="lxc-avisos" aria-live="polite">
    <ng-container *ngFor="let m of responseMessage; trackBy: porMensaje">
      <ng-container *ngTemplateOutlet="alerta; context: {$implicit: m}"></ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #alerta let-m>
  <div class="lx-alerta" [ngClass]="tono(m).clase" [attr.role]="tono(m).rol">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="tono(m).icono"></fa-icon></span>
    <p class="lx-alerta__texto lx-alerta__cuerpo">{{m.summary}}</p>
    <button type="button" class="lx-alerta__cerrar" *ngIf="m.closable" aria-label="Cerrar aviso" (click)="cerrarMensaje(m)">
      <fa-icon [icon]="iconos.cerrar"></fa-icon>
    </button>
  </div>
</ng-template>

<ng-template #seguro>
  <p class="lx-seguro">
    <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
    <span>Tus datos bancarios viajan de forma segura y solo se usan para validar tu cuenta y domiciliar tus pagos.</span>
  </p>
</ng-template>
